import controller from './app-control.controller'
import template from './app-control.html'

export default {
  template,
  controller
}
